window.onload = function() {
    const tumblerImages = document.querySelectorAll('.tumbler-image');
    const selectedTumblerImage = document.getElementById('selected-tumbler-image');
    const selectedBootImage = document.getElementById('selected-boot-image');
    const bootImageSection = document.querySelector('.boot-image-section');
    const bootImages = document.querySelectorAll('.boot-image'); // Preload boot images

    // Dynamically get product data from the hidden div
    const productData = Array.from(document.querySelectorAll('#hidden-products-data .product')).map(product => {
        return {
            id: product.getAttribute('data-id'),
            title: product.getAttribute('data-title'),
            boot_image_id: product.getAttribute('data-boot-image-id'),
            product_variant_id: product.getAttribute('data-product-variant-id'),
            quantity: product.getAttribute('data-quantity') || 1
        };
    });

    // Function to show the boot image based on the boot_image_id
    function showBootImageById(bootImageId) {
        bootImages.forEach(bootImage => {
            const currentBootImageId = bootImage.getAttribute('data-boot-id');
            if (currentBootImageId === bootImageId) {
                selectedBootImage.src = bootImage.querySelector('img').src;
                bootImageSection.style.display = 'block'; // Show boot image section

                // Remove active class from all boot images
                bootImages.forEach(image => image.classList.remove('active'));
                // Add active class to the current boot image
                bootImage.classList.add('active');

                // Find matching product data based on boot_image_id
                const product = productData.find(item => item.boot_image_id === bootImageId);
                if (product) {
                    // Update the product and variant ID in the form
                    document.getElementById('variant-id').value = product.product_variant_id;
                    document.getElementById('product-id').value = product.id;
                    document.getElementById('product-quantity').value = product.quantity; // Set quantity

                    // Log for debugging
                    //console.log('Product ID:', product.id);
                    //console.log('Variant ID:', product.product_variant_id);

                    // Update the URL with product_id, variant_id, and boot_image_id
                    const currentUrl = new URL(window.location.href);
                    currentUrl.searchParams.set('product_id', product.id);
                    currentUrl.searchParams.set('variant_id', product.product_variant_id);
                    currentUrl.searchParams.set('boot_image_id', bootImageId); // Set boot_image_id in URL
                    window.history.pushState({}, '', currentUrl); // Update the URL without reloading
                } else {
                    console.log('No product found for boot_image_id:', bootImageId);
                }
            }
        });
    }

    // Function to show the first tumbler image by default
    function showFirstTumblerImage() {
        if (tumblerImages.length > 0) {
            const firstTumbler = tumblerImages[0]; // Get the first tumbler
            const firstTumblerImageSrc = firstTumbler.querySelector('img').src;

            // Set the first tumbler image
            selectedTumblerImage.src = firstTumblerImageSrc;

            // Add 'active' class to the first tumbler
            firstTumbler.classList.add('active'); 

            // Get the corresponding boot image ID and display it
            const firstBootImageId = firstTumbler.getAttribute('data-boot-id');
            showBootImageById(firstBootImageId); // Show boot image based on tumbler
        }
    }

    // If there's a boot_image_id in the URL, show the corresponding boot image
    const params = new URLSearchParams(window.location.search);
    const bootImageIdFromUrl = params.get('boot_image_id');
    if (bootImageIdFromUrl) {
        showBootImageById(bootImageIdFromUrl); // Show the boot image from URL
    } else {
        // Otherwise, display the first tumbler and boot image by default
        showFirstTumblerImage();
    }

    // Handle tumbler image click (change tumbler, but boot image remains based on URL)
    tumblerImages.forEach(tumbler => {
        tumbler.addEventListener('click', function() {
            // Remove active class from all tumblers and add to the clicked one
            tumblerImages.forEach(tumbler => tumbler.classList.remove('active'));
            tumbler.classList.add('active');

            // Set the selected tumbler image
            const tumblerImageSrc = tumbler.querySelector('img').src;
            selectedTumblerImage.src = tumblerImageSrc;

            // Change the boot image based on the tumbler selection
            const tumblerBootImageId = tumbler.getAttribute('data-boot-id');
            if (tumblerBootImageId) {
                showBootImageById(tumblerBootImageId); // Change the boot image
            }
        });
    });

    // Handle boot image click (change boot image and update the form fields)
    bootImages.forEach(bootImage => {
        bootImage.addEventListener('click', function() {
            // Get the clicked boot image's ID
            const clickedBootImageId = bootImage.getAttribute('data-boot-id');

            // Change the selected boot image to the clicked one
            selectedBootImage.src = bootImage.querySelector('img').src;

            // Add 'active' class to the clicked boot image and remove from others
            bootImages.forEach(image => image.classList.remove('active'));
            bootImage.classList.add('active');

            // Find matching product data based on boot_image_id
            const product = productData.find(item => item.boot_image_id === clickedBootImageId);
            if (product) {
                // Update the product and variant ID in the form
                document.getElementById('variant-id').value = product.product_variant_id;
                document.getElementById('product-id').value = product.id;
                document.getElementById('product-quantity').value = product.quantity;

                // Log for debugging
                //console.log('Updated Product ID:', product.id);
                //console.log('Updated Variant ID:', product.product_variant_id);

                // Update the URL with product_id, variant_id, and boot_image_id
                const currentUrl = new URL(window.location.href);
                currentUrl.searchParams.set('product_id', product.id);
                currentUrl.searchParams.set('variant_id', product.product_variant_id);
                currentUrl.searchParams.set('boot_image_id', clickedBootImageId); // Set boot_image_id in URL
                window.history.pushState({}, '', currentUrl); // Update the URL without reloading
            }
        });
    });
};

document.addEventListener("DOMContentLoaded", function () {
  const productId = getUrlParam("product_id"); // Extract product ID from URL
  const variantId = getUrlParam("variant_id"); // Extract variant ID from URL

  let productQuantity = 1; // Set default quantity to 1

  // Fetch quantity data from the hidden products data container
  const hiddenProductsData = document.querySelectorAll("#hidden-products-data .product");

  if (productId && variantId) {
    hiddenProductsData.forEach((product) => {
      const dataProductId = product.getAttribute("data-id");
      const dataVariantId = product.getAttribute("data-product-variant-id");

      if (dataProductId === productId && dataVariantId === variantId) {
        productQuantity = parseInt(product.getAttribute("data-quantity"), 10);
      }
    });
  }

  // Log data for debugging
  console.log("Product ID:", productId);
  console.log("Variant ID:", variantId);
  console.log("Product Quantity:", productQuantity);

  // Set the hidden input values for productId, variantId, and productQuantity
  if (productId) {
    const productIdInput = document.getElementById("product-id");
    if (productIdInput) productIdInput.value = productId;
  }

  if (variantId) {
    const variantIdInput = document.getElementById("variant-id");
    if (variantIdInput) variantIdInput.value = variantId;
  }

  const productQuantityInput = document.getElementById("product-quantity");
  if (productQuantityInput) {
    productQuantityInput.value = productQuantity; // Set the quantity in the hidden input
  }

  // Add event listener to the button to submit the form
  const addToCartButton = document.getElementById("custom-add-to-cart");
  if (addToCartButton) {
    addToCartButton.addEventListener("click", function (e) {
      const hiddenQuantity = parseInt(document.getElementById("product-quantity").value, 10);

      // Prevent form submission if the product is out of stock
      if (hiddenQuantity === 0) {
        e.preventDefault(); // Prevent form submission
        alert("This product is out of stock."); // Show alert
        return;
      }

      // Ensure that only 1 is added to the cart, even if quantity is changed
      document.getElementById("product-quantity").value = 1;

      // Proceed with form submission if productQuantity is greater than zero
      const form = document.getElementById("custom-add-to-cart-form");
      if (form) form.submit();
    });
  }
});

// Function to get parameters from the URL
function getUrlParam(param) {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(param);
}


var swiper = new Swiper(".tumblerSwiper", {
    slidesPerView: 3,
    spaceBetween: 20,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      640: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
      768: {
        slidesPerView: 4,
        spaceBetween: 20,
      },
      1024: {
        slidesPerView: 6,
        spaceBetween: 20,
      },
      1170: {
        slidesPerView: 7,
        spaceBetween: 30,
      },
    },
});

var swiper = new Swiper(".bootSwiper", {
    slidesPerView: 3,
    spaceBetween: 20,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      640: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
      768: {
        slidesPerView: 4,
        spaceBetween: 20,
      },
      1024: {
        slidesPerView: 6,
        spaceBetween: 20,
      },
      1170: {
        slidesPerView: 7,
        spaceBetween: 30,
      },
    },
});
